module.exports = __webpack_public_path__ + "static/media/t1.497d9d47.png";